import { useKatex } from "@pathwright/utils/src/katex/useKatex"
import classnames from "classnames"
import marked from "marked"
import { useEffect, useRef } from "react"
import { executeScripts } from "../embed/utils"
import { getSchoolURL, isRelativeUrl, routeToRelativeURL } from "../utils/urls"
import "./HtmlText.css"
import { isHTMLEmpty } from "./utils"

function handleRelativeLink(e) {
  e.preventDefault()
  e.stopPropagation()
  const url = e.currentTarget.getAttribute("href")
  return routeToRelativeURL(url)
}

function getRelativeLinks(el) {
  const links = el && el.querySelectorAll("a")
  return [...links].reduce((links, link) => {
    const url = link.getAttribute("href")
    const targetBlank = link.getAttribute("target") === "_blank"
    if (
      url &&
      !targetBlank &&
      url.indexOf("mailto:") === -1 &&
      (isRelativeUrl(url) || url.indexOf(getSchoolURL()) > -1)
    ) {
      return links.concat(link)
    }
    return links
  }, [])
}

const HtmlText = (
  props = {
    latex: false,
    markdown: false,
    quill: false,
    theme: false,
    executeScripts: true,
    truncateAt: null,
    interceptLink: false
  }
) => {
  const nodeRef = useRef(null)

  const getHTML = () => {
    let { html, markdown } = props
    if (markdown) {
      html = marked(html)
    }
    return html
  }

  const { markdown, latex, quill, theme, truncateAt, el } = props
  const html = getHTML()

  useKatex(nodeRef, { enabled: latex === true, contentKey: html })

  useEffect(() => {
    const el = nodeRef.current
    if (!el) {
      return
    }
    if (props.executeScripts) {
      executeScripts(el)
    }
    // Enable relative school URLs
    if (!props.interceptLink) {
      return
    }
    const relativeLinks = getRelativeLinks(el)
    relativeLinks.forEach((link) => {
      link.addEventListener("click", handleRelativeLink)
    })
    return () => {
      relativeLinks.forEach((link) => {
        link.removeEventListener("click", handleRelativeLink)
      })
    }
  }, [])

  const className = classnames(
    "Text",
    {
      "Text--markdown": markdown,
      "Text--latex": latex,
      "Text--quill": quill,
      "Text--theme": theme,
      "Text-truncated": (truncateAt != null) > 0
    },
    props.className
  )
  const El = el ? el : "div"

  return (
    <El
      ref={nodeRef}
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

// Static helpers
HtmlText.isHTMLEmpty = isHTMLEmpty

HtmlText.displayName = "Text"

export default HtmlText
